module.exports = __webpack_public_path__ + "img/2009-4.3772f869.jpg";